import apiService from './api';

const authService = {
  async register(userData) {
    const response = await apiService.post('/auth/register', userData);
    return response;
  },

  async login(credentials) {
    const response = await apiService.post('/auth/login', credentials);
    if (response.success && response.data && response.data.token) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response;
  },

  async verify2FA(userId, token) {
    const response = await apiService.post('/auth/verify-2fa', { userId, token });
    if (response.success && response.data && response.data.token) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response;
  },


  async getProfile() {
    const response = await apiService.get('/auth/profile');
    return response;
  },

  async updateProfile(profileData) {
    const response = await apiService.put('/auth/profile', profileData);
    return response;
  },

  async updateTelegram(telegramUsername) {
    const response = await apiService.put('/auth/update-telegram', { telegram_username: telegramUsername });
    return response;
  },

  async submitKYC(kycData) {
    const response = await apiService.post('/auth/kyc', kycData);
    return response;
  },

  logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  },

  getToken() {
    return localStorage.getItem('token');
  },

  getUser() {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  },

  isAuthenticated() {
    return !!this.getToken();
  },
};

export default authService;